// Example starter JavaScript for disabling form submissions if there are invalid fields
// Source: 'https://getbootstrap.com/docs/4.1/components/forms/#validation' > Custom styles
// Related Bulma validation styles are in file: src/scss/base/form.scss

function attachValidation() {
  // Fetch all the forms we want to apply custom Bulma validation styles to
  var forms = document.getElementsByClassName('needs-validation');
  // Loop over them and prevent submission
  Array.prototype.filter.call(forms, function (form) {
    form.addEventListener('submit', function (event) {
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    }, false);
  });
}

function valueInvalid(elem) {
  return elem.validity !== undefined && elem.validity.valid === false;
}

function valueValid(elem) {
  return elem.validity !== undefined && elem.validity.valid === true;
}

export {
  attachValidation,
  valueInvalid,
  valueValid
};
